<!--

  Auth: dhersey
  Date: 05/06/2025
  Desc: New Form project for Chicago Kickoff Event
    Same thing as BgPbEscape and BgPlanVoyage

-->

<template>

  <div style="margin-bottom: 3em;">
    <div class="debug-box" v-if="isDebug">
      currentStep: {{ currentStep }}
    </div>
    
    <div class="navigation-wrapper">
      <ck-form-tracker 
        :step="currentStep"
        @changeStep="(i) => changeStep(i)"/>
    </div>

    <!-- About -->
    <section class="about-wrapper" :class="isActiveStep(0)">
      <ck-about @close="(i) => changeStep(1)" />
    </section>

    <!-- Lets Party -->
    <section class="lets-party-wrapper" :class="isActiveStep(1)">
      <ck-lets-party @close="(i) => changeStep(1)" />
    </section>

    <!-- Join the Club -->
    <section class="join-club-wrapper" :class="isActiveStep(2)">
      <ck-join-club @close="(i) => changeStep(0)" />
    </section>
  </div>

</template>

<script setup>
  import { ref, toRaw } from 'vue'
  import CkFormTracker from './CkFormTracker.vue';
  import CkAbout from './CkAbout.vue';
  import CkLetsParty from './CkLetsParty.vue';
  import CkJoinClub from './CkJoinClub.vue';

  const isDebug = false;

  let currentStep = ref(0);

  function isActiveStep(i){
    if (i == currentStep.value) {
      return 'active';
    } else {
      return;
    }
  }

  function changeStep(i){
    document.body.scrollTop = document.documentElement.scrollTop = 300;
    
    currentStep.value = i;
  }
</script>

<style lang="scss" scoped>
  section{
    max-width: 100%;
    margin: 0 auto;
    &:not(.active){
      position: absolute;
      top: -9999px;
      left: -9999px;
      display: hidden;
    }
  }

  .debug-box{
    border: 1px dashed black;
  }
</style>